<template>
  <label v-if="title">{{ title }}</label>
  <Editor 
    :id="id" 
    v-model="contentHandler"
    :init="config" 
    model-events="change focus" 
    @selectionChange="handleEditorChange"
    :api-key="apiKey"

  />
</template>

<script>
import { mapGetters } from 'vuex';
import Editor from '@tinymce/tinymce-vue'

export default {
  name: "RichTextEditor",
  components: {
    Editor
  },
  props: {
    id: { type: String, required: true },
    content: { type: String, default: "" },
    title: { type: String, default: undefined }
  },
  emits: [
    "update:content"
  ],
  data() {
    return {
      config: {
        menubar: false,
        toolbar: [ // Groups of toolbar functions, seperated into groups.
          "undo redo",
          "bold italic",
          "h1 h2 h3 h4 h5",
          "alignleft aligncenter alignright",
          "bullist numlist",
          "link",
          "pastetext",
          "code"
        ].join("|"),
        plugins: ["link", "lists", "paste", "code"].join(' '),

        // Paste settings:
        paste_remove_styles: true,
        paste_remove_styles_if_webkit: true,
        paste_preprocess: this.paste_preprocess,
        paste_auto_cleanup_on_paste : true,
        paste_remove_spans: true,
        paste_retain_style_properties: false,
      },
    };
  },
  computed: {
    ...mapGetters('account', [
      'currentOrganization'
    ]),

    apiKey() {
      return this.currentOrganization?.tinyMceCloudApiKey ?? "";
    },

    contentHandler: {
      get() { return this.content },
      set(value) { this.$emit('update:content', value) }
    },

    regex() {
      return {
        stripHtmlTags: RegExp(/<[^>]+>/g),
        stripTabsAndSpaces: RegExp(/^[\s\t]+/gm)
      }
    }
  },
  methods:
  {
    // Gets the cleaned up HTML from the editor.
    // getContent removes all of the WYSIWYG-classes and styling.
    handleEditorChange(_event, editor) {
      this.contentHandler = editor.getContent();
    },

    paste_preprocess(plugin, args) 
    {
      let content = args.content;
      // Replace all escaped html character with their unescaped equivalent.
      content = content.replace(RegExp(/&lt;/g), '<');
      content = content.replace(RegExp(/&gt;/g), '>');
      
      // Split content into lines
      let lines = []

      for(let line of content.split('<br />'))
      {
        line = line.replace(this.regex.stripHtmlTags, '');
        line = line.replace(this.regex.stripTabsAndSpaces, '');

        if (line.length > 0) lines.push(line.trim());
      }

      args.content = lines.join('<br/>');
    }
  }
}

</script>